import {
  customAttributeDataSchema,
  type JSONB,
} from '@risksmart-app/domain/src/types/common.types';
import type { ContentText } from 'pdfmake/interfaces';
import { fieldTypesConfig } from 'src/components/form/custom-attributes/field-types';

import { createField } from '@/utils/pdf/field';

import { getCustomAttributeRenderProps } from '../table/utils/customAttributes';

type CustomAttributeSchemaForExport = {
  Schema: Parameters<typeof getCustomAttributeRenderProps>[0];
  UiSchema: Parameters<typeof getCustomAttributeRenderProps>[1];
};

export function getCustomAttributeDataForExport<
  T extends {
    CustomAttributeData?: JSONB | null;
  },
>(
  item: T,
  schemas: CustomAttributeSchemaForExport | null | undefined
): (ContentText | string)[] {
  const fields: (ContentText | string)[] = [];
  if (!schemas?.Schema || !schemas?.UiSchema) {
    return fields;
  }

  const customAttributeData = customAttributeDataSchema.safeParse(
    item.CustomAttributeData
  );
  if (!customAttributeData.success) {
    return fields;
  }

  const exportItem = {
    ...item,
    CustomAttributeData: customAttributeData.data,
  };

  // render column collections from schemas.
  const collections = getCustomAttributeRenderProps(
    schemas?.Schema || {},
    schemas?.UiSchema || {}
  );
  // map collections to config using type.
  collections.forEach((fieldRenderProps) => {
    const { label, path, type } = fieldRenderProps;
    const rawValue = customAttributeData.data[path];
    const valueFromData = Array.isArray(rawValue)
      ? rawValue.join(',')
      : typeof rawValue === 'boolean'
        ? String(rawValue)
        : (rawValue ?? '');
    const fieldConfig = fieldTypesConfig[type];
    let value;
    if (fieldConfig?.getPdfExportValue) {
      value = fieldConfig.getPdfExportValue(fieldRenderProps, exportItem);
    } else {
      value = valueFromData;
    }
    fields.push(...createField(label, value));
  });

  return fields;
}
